module.exports = __webpack_public_path__ + "static/img/4-1.098c5f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/feature/face/4-1.png
// module id = bW/C
// module chunks = 1